export enum ProductionProcessTypeEnum{
    REPROCESS = 'REPROCESS',
    FRESHPRODUCITON = 'FRESHPRODUCITON',
    REPACKING = 'REPACKING',
    REWORK = 'REWORK'
}